<template>
	<div
		class="property-form"
		:class="{ 'shrink': !isVisible, 'bg-color-editing': isUserEditing !== user.id && isUserEditing }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<!-- loading full screen -->
			<div class="text-center absolute">
				<loading :active.sync="isUploading" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
					<template slot="before">
						<div class="absolute text-lg loading-logo">
							<img src="/img/icon-512.png" height="20" width="20" class="d-inline-block align-top" alt="Grafias">
						</div>
					</template>
					<template slot="after">
						<div>
							<div class="text-lg loading-text mb-2">{{ $t('Uploading') }} {{ mediaProgress }}%</div>
							<div class="mt-2">
								<button class="btn btn-cancel " @click="onCancel">Cancel</button>
							</div>
						</div>
					</template>
				</loading>
			</div>
			<div class="property-title text-uppercase">
				<div class="mr-2" v-if="!showTitle">{{ $t('Media Properties') }} - {{ mediaLabel ? mediaLabel.toUpperCase() : 'Default Media' }}</div>
				<span class="mr-2" v-else :class="{'truncate-media-property-name': mediaLabel.indexOf(' ') <= 0 }">{{ propertyTitle }}</span>
			</div>
		</div>
		<div class="property-content pr-2 " :class="{'pointer-events-none': isLocked    ? isLocked.is_locked   : true}">
			<div class="property-rundown-wrapper custom-scroll pr-2">
				<div class="form-group mb-2">
					<div class="d-flex">
						<div class="d-flex align-items-start">
							<label class="text-primary">
							{{ $t('Media File') }}
							</label>
							<label v-if="isCaching" class="mt-2 ml-2 is-loading"></label>
							<label v-if="isCached" class="ml-2">
								(cached)
								<check-icon :size="15" fillColor="#08ff00" :title="$t('this media is cached and ready for next play!')"></check-icon>
							</label>
						</div>
						<div class="ml-auto" v-if="isNotOptimizedPlayback" v-tooltip="notOptimizedStatus">
							<label class="mr-1"> Not Optimize for Playback</label>
							<alert-icon :size="15" fillColor="red" :title="notOptimizedStatus"></alert-icon>
						</div>
					</div>

					<div class="d-flex flex-row"
						:class="{ 'upload-wrapper-error': !mediaUrl && !mediaFile && !media && isRequired,
						'upload-wrapper': mediaUrl || mediaFile || media || !isRequired }">
						<div class="file-thumbnail-media pointer" v-if="mediaUrl || mediaFile || media">
							<i class="material-icons mt-1" @click="playPreview()" v-if="mediaUrl ==='' && mediaType === 'image'">camera_alt</i>
							<i class="material-icons mt-1" @click="playPreview()" v-if="mediaUrl ==='' && mediaType === 'video'">local_movies</i>
							<img class="mr-2 media-property-thumbnail"
							@click="playPreview()"
							v-if="mediaUrl && data.type === 'image' "
							:src="mediaThumbnail ? mediaThumbnail : mediaUrl" />
							<img class="mr-2 media-property-thumbnail"
							@click="playPreview()"
							v-if="mediaUrl &&  data.type === 'video' "
							:src="mediaThumbnail ? mediaThumbnail : mediaUrl" />
						</div>

						<template v-if="!isUploading && !mediaFile && !media && !mediaUrl" >
							<div class="text-left text-break w-75 mt-4 pointer"
								:class="{'template-center': !mediaFile && !media}">
								<label class="text-underline cur-p text-white">
									<span>Upload</span>
									<input id="mediaInputMp" type="file" accept=".png,.gif,.jpeg,.jpg,.mp4,.mpg,.m4v,.webm"  class="hidden" @change="onMediaSelected">
								</label>
								<span> Image or Video File or Select from </span>
								<span class="text-underline cur-p" @click="openGallery">Gallery</span>
							</div>
						</template>

						<div class="text-left text-break w-75 uploading-text pointer" v-if="isUploading">
								{{ $t('Uploading') }} {{ mediaProgress }}%
						</div>

						<div class="pointer pr-2 file-name-media" v-if="media || mediaUrl !=='' && !isUploading" @click="playPreview()">
							<div class="truncate" :class="{'truncate-media-property-name-upload': checkNameSpace(media && media.name ? media.name : mediaLabel)}">
								{{ media && media.name ? media.name : mediaLabel }}
							</div>
						</div>

						<div class="vertical-line ml-4 mr-4" v-if="mediaUrl !=='' || media || mediaUrl"></div>
						<div class="d-flex flex-column">
							<div class="pointer" @click="openGallery" v-if="mediaFile || media || mediaUrl"><i class="material-icons">folder</i></div>
							<div class="pointer icon-upload-media mb-3"  v-if="mediaFile || media || mediaUrl">
								<label class="text-underline cur-p text-white pt-3 pb-0 mb-0">
									<span class="material-icons">file_upload</span>
									<input type="file" id="mediaInputMp" accept=".png,.gif,.jpeg,.jpg,.mp4,.mpg,.m4v,.webm"  class="hidden" @change="onMediaSelected">
								</label>
								</div>
						</div>
					</div>
					<video
						class="hidden"
						id="video-preview"
						:src="videoUrl"
						@loadedmetadata="onVideoLoaded"
						v-if="mediaType === 'video'">
					</video>
					<canvas id="canvasVideo"
							crossorigin="anonymous"
							class="hidden">
					</canvas>
					<div class="d-flex">
						<!-- Loop Video -->
						<md-switch
							class="md-primary mt-0 mb-3 mr-3"
							:disabled="mediaType !== 'video'"
							v-model="mediaLoop">
							{{ $t('Loop') }}
						</md-switch>
						<!-- video volume -->
						<div class="d-flex" @mouseover="hoverVolume = true" @mouseleave="hoverVolume = false">
							<i class="material-icons font20 mr-2 pointer" v-if="mediaType === 'video' && volumeVideo !== 0" @click="openMutedAudio">volume_up</i>
							<i class="material-icons font20 mr-2 pointer" v-if="mediaType === 'video' && volumeVideo === 0" @click="openUnMutedAudio">volume_off</i>
							<vue-slider
							v-show="hoverVolume && mediaType === 'video'"
							:process-style="{ backgroundColor: '#FFBF44' }"
							:tooltip-style="{ backgroundColor: '#FFBF44', borderColor: '#FFBF44', color: 'black' }"
							class="absolute pr-2 slidevolume"
							v-model="volumeVideo"
							:width="60"
							@dragging="hoverVolume = true"
							></vue-slider>
						</div>
					</div>
					<custom-input
						:class="{'mb-3': mediaType==='video'}"
						type="text"
						align="left"
						:label="$t('Item Label')"
						:max="40"
						:required="isRequired"
						v-model="mediaLabel"
						:restrictChar="true"
					/>
					<!-- in / out video -->
					<div class="row row-thin pr-0 mr-0 pl-0">
						<div class="col-md-6 pr-0 mr-0">
							<custom-input
								v-if="mediaType === 'video'"
								type="duration-timer"
								align="left"
								:maxTime="mediaInMaxDuration"
								:minTime="'0'"
								:label="$t('In Point')"
								:required="isRequired"
								v-model="inPoint"
							/>
						</div>
						<div class="form-group mb-3 col-md-6 pr-0 mr-0">
							<custom-input
								v-if="mediaType === 'video'"
								type="duration-timer"
								align="left"
								:minTime="'1'"
								:maxTime="mediaMaxDuration"
								:label="$t('Out Point')"
								:required="isRequired"
								v-model="outPoint"
							/>

						</div>
					</div>
					<!-- opacity & layer -->
					<div class="row row-thin  " :class="{'flex-row-reverse':mediaType === 'video'}">
						<div class="col-md-6 pr-1 mr-0" v-if="mediaType === 'image'">
							<custom-input
								v-if="mediaType === 'image'"
								type="duration-timer"
								align="left"
								:minTime="'0'"
								:maxTime="86400"
								:label="$t('Duration')"
								:required="isRequired"
								v-model="imageDuration"
							/>
						</div>
						<div class="form-group  col-md-6 pl-1">
							<custom-input
								type="number"
								class="form-control "
								field="index"
								:label="$t('Layer')"
								:required="isRequired"
								:max="100"
								:index-duplicated="isIndexDuplicated"
								v-model="mediaLayerIndex"
							/>
						</div>
						<div class="col-md-6 pr-1 mr-0">
							<custom-input
								class="mb-3"
								type="number"
								:label="$t('Opacity')"
								:required="isRequired"
								:min="0"
								:max="100"
								:step="1"
								:suffix="'%'"
								v-model="mediaOpacity"
							/>
							<div></div>
						</div>
					</div>
				<!-- Border -->
				<div>
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Border') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch
								class="md-primary mt-0 mb-2 mr-0"
								v-model="isEnableBorder">
							</md-switch>
						</div>
					</div>
				</div>
				<div class="row mb-0 pb-0">
					<div class="col-md-6 pr-1 mr-0">
						<custom-input
							class="mb-4 pb-0"
							type="number"
							:label="$t('Thickness')"
							:required="isRequired"
							:min="0"
							:max="1000"
							:step="1"
							:disabled="!isEnableBorder"
							v-model="borderThickness"
						/>
					</div>
					<div class="col-md-6 pl-1">
						<custom-input
							type="color"
							align="left"
							picker-position="right"
							:label="$t('Color')"
							:required="isRequired"
							:disabled="!isEnableBorder"
							:class="{'disabled': !isEnableBorder}"
							:isEnableBorder="isEnableBorder"
							v-model="borderColor"
						/>
					</div>
				</div>
				<div class="mt-2">
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Crop media') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch
								class="md-primary mt-0 mb-2 mr-0"
								v-model="isEnableCrop">
							</md-switch>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 pr-0 mr-0 pr-1">
							<custom-input
								class="mb-3"
								type="number"
								:label="$t('Top')"
								:required="isRequired"
								:min="0"
								:max="8000"
								:step="1"
								v-model="cropTop"
								:suffix="'px'"
								:disabled="!isEnableCrop"
							/>
						</div>
						<div class="col-md-6 pl-1">
							<custom-input
								class="mb-3"
								type="number"
								:label="$t('Bottom')"
								:required="isRequired"
								:min="0"
								:max="8000"
								:step="1"
								:suffix="'px'"
								v-model="cropBottom"
								:disabled="!isEnableCrop"
							/>
						</div>
						<div class="col-md-6 pr-0 mr-0 pr-1">
							<custom-input
								class="mb-4"
								type="number"
								:label="$t('Left')"
								:required="isRequired"
								:min="0"
								:max="8000"
								:step="1"
								v-model="cropLeft"
								:suffix="'px'"
								:disabled="!isEnableCrop"
							/>
						</div>
						<div class="col-md-6 pl-1">
							<custom-input
								class="mb-4"
								type="number"
								:label="$t('Right')"
								:required="isRequired"
								:min="0"
								:max="8000"
								:step="1"
								:suffix="'px'"
								v-model="cropRight"
								:disabled="!isEnableCrop"
							/>
						</div>
				</div>
					<!-- Size and Position -->
					<div class="mt-2">
						<position-settings
							:width.sync="mediaWidth"
							:height.sync="mediaHeight"
							:position.sync="mediaPosition"
							:blendmode.sync="blendMode"
							:x.sync="mediaX"
							:y.sync="mediaY"
							:isRatio.sync="isRatio"
							:isPosition.sync="isPosition"
							:type="data.type"
							@rescale="rescaleSize"
							@reset="resetSizePosition"
							:isBlendActive="true"
							:originalWidth="mediaOriginalWidth"
							:originalHeight="mediaOriginalHeight"
						/>
					</div>
				</div>
				<div class="mt-2" >
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('On Complete') }}</label>
						</div>
						<!-- <div class="ml-0 pl-0">
							<md-switch
								class="md-primary mt-0 mb-2 mr-0"
								v-model="isParent"
								@change="saveMedia()">
							</md-switch>
						</div> -->
					</div>
				</div>
				<!-- on complete controller -->
				<div :class="{'disabled': mediaLoop}">
					<md-menu
						:md-active.sync="isOnComplete"
						class="h-fc col-md-12 pr-0 pl-0"
						md-size="small"
						md-direction="top-start"
						md-align-trigger>
						<div v-if="selectedOnComplete"
							:class="{'disabled-item': mediaLoop}"
							class="form-control cur-p relative mb-4"
							md-menu-trigger>
							<item-option
								:item="selectedOnComplete"
								v-if="selectedOnComplete"
							/>
							<div class="text-right">
								<div @click.stop="removeOnComplete" class="modal-close-assets absolute delete-complete-add">
									<i class="material-icons">cancel</i>
								</div>
							</div>
						</div>
						<div v-else md-menu-trigger>
							<input
								:class="{'disabled-item': mediaLoop}"
								type="text"
								class="form-control mb-4"
								:placeholder="$t('Stop (default)')"
								v-model="keywordSearchOnComplete"
								@click.stop="toggleOnComplete"
							/>
							<item-option
								:item="selectedOnComplete"
								v-if="selectedOnComplete"
							/>
						</div>
						<md-menu-content id="scrolls-style"
						:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
							'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
							'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
							'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
							}"
							>
							<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
								v-for="rundownItem in filteredParent"
								:key="rundownItem.id"
								@click="selectOnComplete(rundownItem)">
								<item-option :item="rundownItem" />
							</md-menu-item>
							<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
								Oops, there is no assets available
							</md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- parent controller -->
				<div class="mt-2">
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Parent Controller') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch
								class="md-primary mt-0 mb-2 mr-0"
								v-model="isParent">
							</md-switch>
						</div>
					</div>
				</div>
				<div class="flex-center">
					<!-- new dropdown select assets -->
					<md-menu
						:md-active.sync="isToggleParent"
						class="h-fc mr-2 w-100"
						md-size="small"
						md-direction="top-start"
						md-align-trigger>
						<div v-if="selectedParent"
							class="form-control cur-p relative w-100"
							md-menu-trigger>
							<item-option
								:item="selectedParent"
								v-if="selectedParent"
							/>
							<div @click.stop="removeParent" class="modal-close-assets absolute delete-assets-add">
								<i class="material-icons">cancel</i>
							</div>
						</div>
						<div v-else md-menu-trigger>
							<input
								type="text"
								class="form-control w-100"
								:placeholder="$t('Search or Select Parent Item')"
								v-model="keywordSearchParent"
								@click.stop="toggleParent"
							/>
							<item-option
								:item="selectedParent"
								v-if="selectedParent"
							/>
						</div>
						<md-menu-content id="scrolls-style"
						:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
							'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
							'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
							'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
							}"
							>
							<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
								v-for="rundownItem in filteredParent"
								:key="rundownItem.id"
								@click="selectParent(rundownItem)">
								<item-option :item="rundownItem" />
							</md-menu-item>
							<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list w-100">
								Oops, there is no assets available
							</md-menu-item>
						</md-menu-content>
					</md-menu>
					<!-- delay -->
					<div class="select">
						<div class="w-100">
							<custom-input
								class="form-input"
								type="number"
								:label="$t('Delay')"
								:min="-15000"
								:max="15000"
								:step="100"
								:suffix="'ms'"
								v-model="childOrder"
								:allowNegative="true"
							/>
						</div>
					</div>
				</div>
				<div class="d-flex mt-4">
					<button @click="saveMedia()"
						:class="{ 'is-loading': isSaving }"
						class="btn btn-primary btn-sm mr-2">
						{{ $t('Save Changes') }}
					</button>
					<button @click="closeForm()"
						class="btn btn-secondary btn-sm">
						{{ $t('Cancel') }}
					</button>
				</div>
			</div>

		</div>
		<!-- Muted Confirmation -->
			<modal
				size="small"
				@close="cancelMuted"
				v-if="isShowModalConfirmMuted">
				<template slot="header">
					<span v-if="mediaMute">{{ $t('Muted Audio') }}</span>
					<span v-if="!mediaMute">{{ $t('Unmuted Audio') }}</span>
				</template>
				<template slot="body">
					<span v-if="mediaMute">{{ $t('Are you sure want to mute the Audio') }}?</span>
					<span v-if="!mediaMute">{{ $t('Are you sure want to unmute the Audio') }}?</span>
				</template>
				<template slot="footer">
					<!-- muted -->
					<div class="w-100 flex-center">
						<button
							@click="checkMuteSave()"
							class="btn btn-primary">
							<span v-if="mediaMute">{{ $t('Muted') }}</span>
							<span v-if="!mediaMute">{{ $t('Unmuted') }}</span>
						</button>
						<button
							class="btn btn-default"
							@click="cancelMuted">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { Video } from 'video-metadata-thumbnails';
import checkIcon from 'vue-material-design-icons/CheckCircle.vue';
import alertIcon from 'vue-material-design-icons/Alert.vue';
// eslint-disable-next-line
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

import { mapGetters } from 'vuex';
import localforage from 'localforage';

import urlExists from 'url-exists';
// import Multiselect from 'vue-multiselect';
import ItemOption from '@/components/ItemOption.vue';
import Modal from '@/components/Modal.vue';
import {
	getAxiosErrorMessage,
	duplicateVar,
	delay,
	getVideoBlob,
	toTitleCase,
} from '@/lib/helper';
import {
	delayList,
} from '@/lib/statics';
import rundownItemsApi from '@/api/rundownItems';
import fileApi from '@/api/file';
import mediasApi from '@/api/medias';
// import userApi from '@/api/user';

import PositionSettings from '@/components/PositionSettings.vue';
import CustomInput from '@/components/CustomInput.vue';

export default {
	name: 'MediaProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		media: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		PositionSettings,
		CustomInput,
		checkIcon,
		Loading,
		Modal,
		// Multiselect,
		ItemOption,
		alertIcon,
		VueSlider,
	},
	data() {
		return {
			mediaFile: '',
			mediaUrl: '',
			mediaLabel: '',
			mediaThumbnail: '',
			mediaId: '',
			mediaLoop: false,
			mediaOpacity: 100,
			mediaLayerIndex: 1,
			childOrder: 0,
			mediaWidth: 0,
			mediaHeight: 0,
			mediaPosition: 'default',
			blendMode: 'normal',
			mediaX: 0,
			mediaY: 0,
			cropTop: 0,
			cropBottom: 0,
			cropLeft: 0,
			cropRight: 0,
			mediaType: 'image',
			progress: 0,
			isUploading: false,
			isEnableCrop: false,
			isSaving: false,
			isVisible: true,
			mediaOriginalWidth: 0,
			mediaOriginalHeight: 0,
			mediaMute: false,
			mediaProgress: 0,
			isLoading: false,
			duration: 0, // in seconds
			isRequired: false,
			isRatio: true,
			isPosition: false,
			isFetchingMedia: false,
			isCaching: false,
			isCached: false,
			// mediaItems: [],
			isEnableBorder: false,
			borderColor: '#FFFFFF',
			borderThickness: 1,
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			isActiveEdit: false,
			// loader
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			localClientUser: {},
			cancelUpload: null,
			isShowModalConfirmMuted: false,
			isAdding: false,
			hasPlayed: false,
			parentItem: null,
			isParent: false,
			// isShowModalConfirnParent: false,
			delayList,
			selectedParent: null,
			selectedOnComplete: null,

			keywordSearchParent: '',
			keywordSearchOnComplete: '',
			outPoint: '00:00:00',
			inPoint: '00:00:00',
			mediaDuration: '',
			isToggleParent: false,
			isOnComplete: false,
			isNotOptimizedPlayback: false,
			notOptimizedStatus: '',
			// storage warn
			isStorage99Percent: false,
			isStorage80Percent: false,
			currentStorage: false,
			availableStorage: false,
			hoverVolume: false,
			volumeVideo: 100,
			imageDuration: '02:00:00',
		};
	},
	methods: {
		closeForm() {
			this.$emit('close');
		},
		toggleParent() {
			this.isToggleParent = true;
		},
		toggleOnComplete() {
			this.isOnComplete = true;
		},
		onSelect() {

		},
		openUnMutedAudio() {
			this.isShowModalConfirmMuted = true;
			this.mediaMute = false;
		},
		openMutedAudio() {
			this.isShowModalConfirmMuted = true;
			this.mediaMute = true;
		},
		cancelMuted() {
			this.isShowModalConfirmMuted = false;
			this.mediaMute = !this.mediaMute;
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		onCancel() {
			if (this.cancelUpload) {
				this.cancelUpload();
				this.mediaFile = null;
				this.isCaching = false;
				this.isCached = false;
				this.isUploading = false;
			}
		},
		playPreview() {
			if (this.data.is_Locked) return; // Disable when ed
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			} else {
				return;
			}
			const id = this.data.id;
			const status = 'preview';
			// eslint-disable-next-line no-unused-vars
			const callback = (response) => {
				// const items = response.data;
			};
			const errorCallback = () => {
			};
			const userActivateAllItem = this.userSettings && this.userSettings.is_enable_all_preview ? this.userSettings.is_enable_all_preview : false;
			const params = {
				isAllItem: userActivateAllItem,
			};
			rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
		},

		async initData() {
			this.isVisible = true;
			this.reset();

			if (this.data) {
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}

				this.mediaLayerIndex = this.data.layer_index;
				this.mediaLabel = this.data.name;
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				if (content) {
					if (content && !content.id && content.url) await this.getMediaByUrl(content && content.url ? content.url : '');
					this.mediaUrl = content.url;
					const videoKey = `media_${content.id}`;
					this.checkCached(videoKey);

					this.mediaId = content.id;
					this.mediaType = content.type || 'image';
					this.mediaLoop = content.loop;
					this.mediaThumbnail = content.thumbnail;
					this.mediaOpacity = content.opacity * 100;
					this.mediaWidth = content.width;
					this.mediaHeight = content.height;
					this.mediaPosition = content.position;
					this.mediaOriginalWidth = content.original_width;
					this.mediaOriginalHeight = content.original_height;
					this.blendMode = content.blendMode;
					this.mediaX = content.x;
					this.mediaY = content.y;
					this.mediaMute = content.muted;
					this.isRatio = content.isRatio;
					this.isPosition = content.isPosition;
					this.cropTop = content.cropTop || 0;
					this.cropBottom = content.cropBottom || 0;
					this.cropLeft = content.cropLeft || 0;
					this.cropRight = content.cropRight || 0;
					this.isEnableCrop = content.isEnableCrop;
					if (content.duration) this.duration = content.duration;
					this.isEnableBorder = content.isEnableBorder;
					this.borderColor = content.borderColor || '#FFFFFF';
					this.borderThickness = content.borderThickness || 0;
					this.hasPlayed = content.hasPlayed;
					this.isParent = content.isParent || false;
					// this.parentItem = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.childOrder = content.childOrder || 0;
					this.inPoint = content.inPoint || '00:00:00';
					this.outPoint = content.outPoint || this.getExistingOldDuration;
					this.volumeVideo = content.volumeVideo || 100;
					this.imageDuration = content.imageDuration || '02:00:00';
				}
			}
		},
		checkCached(videoKey) {
			localforage.getItem(videoKey).then((value) => {
				if (value) {
					let content = this.data.content;
					if (typeof content === 'string') {
						content = JSON.parse(content);
					}
					if (content.url) this.isCached = true;
					this.checkVideoSpec(value);
				} else {
					this.isCached = false;
				}
			});
		},
		reset() {
			this.mediaId = '';
			this.mediaFile = '';
			this.mediaUrl = '';
			this.mediaType = 'image';
			this.mediaLoop = false;
			this.mediaLabel = '';
			this.mediaOpacity = 100;
			this.mediaLayerIndex = 1;
			this.mediaWidth = 1920;
			this.mediaHeight = 1080;
			this.cropTop = 0;
			this.cropBottom = 0;
			this.cropLeft = 0;
			this.cropRight = 0;
			this.isEnableCrop = false;
			this.mediaPosition = 'default';
			this.blendMode = 'normal';
			this.mediaX = 0;
			this.mediaY = 0;
			this.videoUrl = '';
			this.mediaMute = false;
			this.duration = 0;
			this.isRatio = true;
			this.isPosition = false;
			this.borderThickness = 0;
			this.isEnableBorder = 0;
			this.borderColor = '#FFFFFF';
			this.hasPlayed = false;
			this.childOrder = 0;
			this.inPoint = '00:00:00';
			this.outPoint = '00:00:00';
			this.volumeVideo = 100;
			this.imageDuration = '02:00:00';
		},
		
		_arrayBufferToBase64(buffer) {
			let binary = '';
			const bytes = new Uint8Array(buffer);
			const len = bytes.byteLength;
			for (let i = 0; i < len; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			return window.btoa(binary);
		},
		onMediaSelected(e) {
			this.initDataUser();
			this.availableStorage = 0;
			this.currentStorage = 0;
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // make it "infinite" when no limiter is set
			}
			// upload
			let files = e.target.files;

			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg'
					|| files[0].type === 'video/mp4' || files[0].type === 'video/mpg' || files[0].type === 'video/m4v' || files[0].type === 'video/webm') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
						// check storage
							if (this.rundownStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									this.isCached = false;
									this.isCaching = false;
									if (document.querySelector('#mediaInputMp')) document.querySelector('#mediaInputMp').value = '';
									return;
								}
								// eslint-disable-next-line no-else-return
							}
							// if (!this.mediaItems.some(data => data.name === files[0].name) && !this.mediaItems.some(data => data.size === files[0].size)) {
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warning',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}

							const reader = new FileReader();
							// checking media info
							this.checkVideoSpec(file);
							reader.onload = () => {
								this.isUploading = true;
								this.fileSize = file.size / oneMB;
								this.mediaFile = file;
								this.hasPlayed = false;
								// Remove extension from filename to set label
								let filename = duplicateVar(file.name);
								filename = filename.split('.').slice(0, -1).join('.');
								this.mediaLabel = duplicateVar(filename);

								const fileType = file.type.includes('video') ? 'video' : 'image';

								// init size image to fit in canvas
								const outputSize = localStorage.getItem(`default_output_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_output_size_${this.user.id}`)) : null;
								const outputSizeWidth = outputSize && outputSize.width ? outputSize.width : 1920;
								const outputSizeHeight = outputSize && outputSize.height ? outputSize.height : 1080;
								// start set data
								if (fileType === 'image') {
									const image = new Image();
									const imageSrc = URL.createObjectURL(file);
									image.src = imageSrc;
									image.onload = () => {
										const originalWidth = image.width;
										const originalHeight = image.height;
										this.mediaOriginalWidth = originalWidth;
										this.mediaOriginalHeight = originalHeight;
										// change size based on ratio and canvas
										const ratioOriginal = Math.min(outputSizeWidth / originalWidth, outputSizeHeight / originalHeight);
										this.mediaWidth = originalWidth * ratioOriginal;
										this.mediaHeight = originalHeight * ratioOriginal;
										// change position
										this.mediaX = (outputSizeWidth - this.mediaWidth) / 2;
										this.mediaY = (outputSizeHeight - this.mediaHeight) / 2;
										this.uploadMedia(file, 'image', imageSrc);
									};
								} else {
								// this.videoUrl = theFile.target.result;
									this.uploadMedia(file, 'video');
								}
							};
							reader.readAsArrayBuffer(file); // use array buffer instead of blob
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#mediaInputMp')) document.querySelector('#mediaInputMp').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						this.isCached = false;
						this.isCaching = false;
						if (document.querySelector('#mediaInputMp')) document.querySelector('#mediaInputMp').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		checkVideoSpec(blob) {
			const getSize = () => blob.size;
			const readChunk = (chunkSize, offset) => new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (event) => {
					if (event.target.error) {
						reject(event.target.error);
					}
					resolve(new Uint8Array(event.target.result));
				};
				reader.readAsArrayBuffer(blob.slice(offset, offset + chunkSize));
			});
			// eslint-disable-next-line no-undef
			MediaInfo({ format: 'JSON' }, (mediainfo) => {
				mediainfo.analyzeData(getSize, readChunk)
					.then((result) => {
						const info = result && result.length > 0 ? JSON.parse(result) : null;
						const tracks = info && info.media && info.media.track ? info.media.track : null;
						const trackIndex = tracks.findIndex(track => track['@type'] === 'Video');
						if (trackIndex !== -1) {
							const mb5 = 5000000; /* 5Mbps */
							if ((tracks && tracks[trackIndex].BitRate > mb5) && !(tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								this.isNotOptimizedPlayback = true;
								this.notOptimizedStatus = 'Video is exceeding the recommended limit for Web Playback, recomended bitrate is lower than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
								this.$notify({
									group: 'app',
									type: 'warning',
									text: 'Video is exceeding the recommended limit for Web Playback, recomended bitrate is lower than 5MB <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>',
									duration: 99999,
								});
							} else if (!(tracks && tracks[trackIndex].BitRate > mb5) && (tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								this.isNotOptimizedPlayback = true;
								this.notOptimizedStatus = 'Video is larger than 1920 x 1080, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
								this.$notify({
									group: 'app',
									type: 'warning',
									text: 'Video is larger than 1920 x 1080, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>',
									duration: 99999,
								});
							} else if ((tracks && tracks[trackIndex].BitRate > mb5) && (tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								this.isNotOptimizedPlayback = true;
								this.notOptimizedStatus = 'Video is larger than 1920 x 1080 and bitrate is larger than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>';
								this.$notify({
									group: 'app',
									type: 'warning',
									text: 'Video is larger than 1920 x 1080 and bitrate is larger than 5MB, <a href="https://docs.grafiaslive.com/docs/faq/untitled-66" target="_blank"> performance issue might occurred </a>',
									duration: 99999,
								});
							} else if (!(tracks && tracks[trackIndex].BitRate > mb5) && !(tracks[trackIndex].Width > 1920 && tracks[trackIndex].Height > 1080)) {
								// when track is valid
								this.notOptimizedStatus = 'No performance issue';
							}
						}
					})
					.catch(() => {
						// console.log(error);
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'cannot read your video meta data info',
						});
					});
			});
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048;
				}
			}
		},
		async uploadMedia(file, type, fileResult = null) {
			const params = new FormData();
			params.append('file', file);
			if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
			// get duration
			if (type === 'video') {
				const video = document.createElement('video');
				video.preload = 'metadata';
				video.onloadedmetadata = () => {
					this.duration = video.duration;
					const duration = video.duration;
					// get range duration
					const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
					const minutes = parseInt(parseInt(duration % 3600) / 60);
					const seconds = parseInt(duration % 60);
					const hoursLabel = hours < 10 ? `0${hours}` : hours;
					const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
					const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
					const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
					this.mediaDuration = durationLabel;
					// reset value to default if user change the media
					this.inPoint = '00:00:00';
					this.outPoint = durationLabel;
				};
				video.src = URL.createObjectURL(file);
			}
			const callback = async (response) => {
				const mediaUrl = response.data;
				this.mediaUrl = mediaUrl;
				// init size image to fit in canvas
				const outputSize = localStorage.getItem(`default_output_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_output_size_${this.user.id}`)) : null;
				const outputSizeWidth = outputSize && outputSize.width ? outputSize.width : 1920;
				const outputSizeHeight = outputSize && outputSize.height ? outputSize.height : 1080;
				// start set data
				this.isUploading = false;
				if (type === 'video') {
					const video = new Video(file);
					const thumbnail = await video.getThumbnails({
						quality: 0.7,
						start: 0,
						end: 10,
					});
					const thumbnailBlob = thumbnail && thumbnail.length > 0 && thumbnail[0].blob ? [thumbnail[0].blob] : null;
					if (thumbnailBlob) await this.uploadThumbnailVideo(file, new File(thumbnailBlob, `${this.mediaLabel}.jpg`), this.duration);

					const videoPreview = document.createElement('video');
					videoPreview.preload = 'metadata';
					// console.log(videoPreview.duration);
					videoPreview.onloadedmetadata = () => {
						window.URL.revokeObjectURL(video.src);
						const width = videoPreview.videoWidth;
						const height = videoPreview.videoHeight;
						const duration = videoPreview.duration;
						this.mediaOriginalWidth = width;
						this.mediaOriginalHeight = height;
						this.duration = duration;
						// change size based on ratio and canvas
						const ratioOriginal = Math.min(outputSizeWidth / width, outputSizeHeight / height);
						this.mediaWidth = width * ratioOriginal;
						this.mediaHeight = height * ratioOriginal;
						// change position
						this.mediaX = (outputSizeWidth - this.mediaWidth) / 2;
						this.mediaY = (outputSizeHeight - this.mediaHeight) / 2;
					};
					videoPreview.src = URL.createObjectURL(file);
				} else if (fileResult) {
					this.compressImage(fileResult, `thumbnail-${this.mediaLabel}.jpg`).then(async (fileThumbnail) => {
						await this.uploadThumbnailImage(file, fileThumbnail);
					});
				}
				this.mediaProgress = 0;
				const isSame = false; // this trigger to recache display
				if (document.querySelector('#mediaInputMp')) document.querySelector('#mediaInputMp').value = ''; if (this.rundownStorage) {
					const oneMB = 1048576; // MB
					// on the spot 100%
					const resultSizeFile = file.size / oneMB;
					// eslint-disable-next-line
					const isStorageOnTheSpot100 = this.rundownStorage.total_remaining_size == resultSizeFile;
					// right on 80% mark
					const resultPercentage80 = this.rundownStorage.total_max_file_size * 80 / 100;
					const fixTotalUsageAndFile80 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
					// eslint-disable-next-line
					const isStorageOnTheSpot80 = fixTotalUsageAndFile80 >= resultPercentage80 && this.rundownStorage.total_used_file_size < resultPercentage80;
					// right on 99% mark
					const resultPercentage99 = this.rundownStorage.total_max_file_size * 99 / 100;
					const fixTotalUsageAndFile99 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
					// eslint-disable-next-line
					const isStorageOnTheSpot99 = fixTotalUsageAndFile99 >= resultPercentage99 && this.rundownStorage.total_used_file_size < resultPercentage99;
					if (isStorageOnTheSpot100) {
						const message = 'Your total used Storage is 100%';
						this.$notify({
							group: 'app',
							type: 'warning',
							title: 'Upload Media',
							text: message,
						});
					} else if (isStorageOnTheSpot99) {
						const message = 'Your total used Storage is over 99%';
						this.$notify({
							group: 'app',
							type: 'warning',
							title: 'Upload Media',
							text: message,
						});
						this.isStorage99Percent = true;
						this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage99;
						this.availableStorage = this.rundownStorage.total_max_file_size;
					} else if (isStorageOnTheSpot80) {
						const message = 'Your total used Storage is over 80%';
						this.$notify({
							group: 'app',
							type: 'warning',
							title: 'Upload Media',
							text: message,
						});
						this.isStorage80Percent = true;
						this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage80;
						this.availableStorage = this.rundownStorage.total_max_file_size;
					}
				}
			};
			const errorCallback = (e) => {
				const messageFromCallback = getAxiosErrorMessage(e) || 'request has been cancelled';
				const message = messageFromCallback && messageFromCallback !== '' ? messageFromCallback : 'Error when uploading file';
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Upload Media',
					text: message,
					duration: 999999999,
				});
				this.mediaLabel = '';
				this.mediaFile = '';
				this.mediaUrl = '';
				this.mediaThumbnail = '';
				this.duration = '';
				this.inPoint = '00:00:00';
				this.outPoint = '00:00:00';
				this.isCaching = false;
				this.isCached = false;
				this.isUploading = false;
			};
			const progressCallback = (progress) => {
				this.mediaProgress = progress;
			};

			const cancelUploadCallback = (c) => {
				this.cancelUpload = c;
			};
			fileApi.upload(params, callback, errorCallback, progressCallback, cancelUploadCallback);
		},
		addMedia(file, fileThumbnail, duration) {
			this.isAdding = true;
			const content = {
				warningMessage: this.notOptimizedStatus,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: this.mediaLabel,
				path: this.mediaUrl,
				type: this.mediaType,
				thumbnail: this.mediaThumbnail,
				rundown_id: this.rundown.id || null,
				category_id: 1,
				size: this.fileSize,
				content: contentString,
			};
			if (this.mediaType === 'video') params.content = contentString;
			if (duration) params.duration = duration;
			const callback = (response) => {
				const item = response.data;
				this.mediaId = item.id;

				const mediaKey = `media_${this.mediaId}`;
				const thumbnailKey = `thumbnail_${this.mediaId}`;

				// const videoKey = `media_${this.data.id}`;
				const blob = new Blob([file]);
				const tumbnailBlob = new Blob([fileThumbnail]);
				// localforage.removeItem(mediaKey, (err) => {
				// 	if (!err) {
				// 		this.$notify({
				// 			group: 'app',
				// 			type: 'success',
				// 			title: 'Media Saved',
				// 			text: 'Media is being cached in the background',
				// 		});
				// 	}
				// });
				localforage.setItem(mediaKey, blob, (err) => {
					if (!err) {
						this.isCaching = false;
						this.isCached = true;
						this.$notify({
							group: 'app',
							type: 'success',
							title: 'Media Saved',
							text: 'Media is cached',
						});
					}
				});
				// localforage.removeItem(thumbnailKey, (err) => {
				// 	if (!err) {
				// 		// this.$notify({
				// 		// 	group: 'app',
				// 		// 	type: 'success',
				// 		// 	title: 'Media Saved',
				// 		// 	text: 'Media is being cached in the background',
				// 		// });
				// 	}
				// });
				localforage.setItem(thumbnailKey, tumbnailBlob, (err) => {
					if (!err) {
						// this.isCaching = false;
						// this.isCached = true;
						// this.$notify({
						// 	group: 'app',
						// 	type: 'success',
						// 	title: 'Media Saved',
						// 	text: 'Media is cached',
						// });
					}
				});
				this.isAdding = false;
				if (this.isStorage80Percent || this.isStorage99Percent) this.notifyEmailStorage();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isAdding = false;
				this.isCaching = false;
				this.isCached = false;
				this.availableStorage = 0;
				this.currentStorage = 0;
			};
			mediasApi.create(params, callback, errorCallback);
		},
		compressImage(result, fileName) {
			const promise = new Promise((resolve, reject) => {
				try {
					const width = 160;
					const height = 90;
					const img = new Image();
					img.src = result;
					img.onload = () => {
						const elem = document.createElement('canvas');
						elem.width = width;
						elem.height = height;
						const hRatio = elem.width / img.width;
						const vRatio = elem.height / img.height;
						const ratio = Math.min(hRatio, vRatio);
						// eslint-disable-next-line
						const centerShift_x = (elem.width - img.width * ratio) / 2;
						// eslint-disable-next-line
						const centerShift_y = (elem.height - img.height * ratio) / 2;
						const ctx = elem.getContext('2d');
						// img.width and img.height will contain the original dimensions
						ctx.clearRect(0, 0, elem.width, elem.height);
						ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);
						ctx.canvas.toBlob((blob) => {
							const file = new File([blob], fileName, {
								type: 'image/jpeg',
								lastModified: Date.now(),
							});
							// this.uploadThumbnailImage(file);
							resolve(file);
						}, 'image/jpeg', 1);
					};
				} catch (e) {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Upload Thumbnail',
						text: 'Something went wrong when upload thumbnail',
					});
					reject(e);
				}
			});
			return promise;
		},
		async uploadThumbnailImage(file, fileThumbnail) {
			const promise = new Promise((resolve, reject) => {
				const callback = (response) => {
					const mediaUrl = response.data;
					this.mediaThumbnail = mediaUrl;
					this.isUploading = false;
					this.mediaProgress = 0;
					this.addMedia(file, fileThumbnail);
					resolve();
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Upload Media',
						text: message,
					});
					this.isUploading = false;
					this.isCaching = false;
					this.isCached = false;
					reject();
				};
				const progressCallback = (progress) => {
					this.mediaProgress = progress;
				};

				const params = new FormData();
				params.append('file', fileThumbnail);
				if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
				fileApi.upload(params, callback, errorCallback, progressCallback);
			});
			return promise;
		},
		uploadThumbnailVideo(file, fileThumbnail, duration) {
			const params = new FormData();
			params.append('file', fileThumbnail);
			if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
			const promise = new Promise((resolve, reject) => {
				const callback = (response) => {
					const mediaUrl = response.data;
					this.mediaThumbnail = mediaUrl;
					this.isUploading = false;
					// localStorage.setItem(`isUploading_${this.data.id}`, this.isUploading);
					this.mediaProgress = 0;
					this.addMedia(file, fileThumbnail, duration);
					resolve(response);
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Upload Media',
						text: message,
					});
					reject(new Error(message));
					this.isUploading = false;
					// localStorage.setItem(`isUploading_${this.data.id}`, this.isUploading);
					this.isCaching = false;
					this.isCached = false;
				};
				const progressCallback = (progress) => {
					this.mediaProgress = progress;
				};
				fileApi.upload(params, callback, errorCallback, progressCallback);
			});
			return promise;
		},
		notifyEmailStorage() {
			const callback = () => {
				this.availableStorage = 0;
				this.currentStorage = 0;
				this.isStorage99Percent = false;
				this.isStorage80Percent = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			const params = {
				current_storage: this.currentStorage,
				available_storage: this.availableStorage,
			};
			mediasApi.notifyEmail(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				// this.fetch(true);
			}, 1200);
		},
		cacheDisplays() {
			const callback = () => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Media Saved',
					text: `Rebuilding cache for ${this.data.name}`,
				});
			};
			const callbackError = () => {
			};
			const params = {
				display_name: '',
			};
			rundownItemsApi.cacheDisplay(this.data.id, params, callback, callbackError);
		},
		saveMediaFromInput(isSame = true) {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				this.isMediaFormVisible = false;
				if (!isSame) this.cacheDisplays();
			};
			const errorCallback = () => {
				this.isSaving = false;
				this.isCaching = false;
				this.isCached = false;
			};
			if (this.data) {
				rundownItemsApi.update(this.data.id, this.mediaParams, callback, errorCallback);
			} else {
				rundownItemsApi.create(this.mediaParams, callback, errorCallback);
			}
		},
		checkMuteSave() {
			const callback = () => {
				// insert your function here
				this.isShowModalConfirmMuted = false;
			};
			const errCallback = () => {
				// insert your function here
				this.isShowModalConfirmMuted = false;
			};
			const params = {
				id: this.data.id || null,
				status: this.mediaMute,
			};
			if (this.mediaMute) {
				this.volumeVideo = 0;
			} else {
				this.volumeVideo = 100;
			}
			rundownItemsApi.mute(params.id, params.status, callback, errCallback);
		},
		saveMedia() {
			this.hoverVolume = false;
			if (this.isVisible) {
				this.isSaving = true;
				const callback = (response) => {
					const item = response.data;
					this.$emit('add', item);
					this.isSaving = false;
					this.isMediaFormVisible = false;
					this.closeForm();
				};
				const errorCallback = () => {
					this.isSaving = false;
					this.closeForm();
				};
				if (this.data) {
					rundownItemsApi.update(this.data.id, this.mediaParams, callback, errorCallback);
				} else {
					rundownItemsApi.create(this.mediaParams, callback, errorCallback);
				}
			} else {
				this.isVisible = true;
			}
		},
		openGallery() {
			this.$emit('browse');
		},
		onVideoLoaded() {
			const videoPreview = document.getElementById('video-preview');
			if (videoPreview) {
				const width = videoPreview.videoWidth;
				const height = videoPreview.videoHeight;
				const duration = videoPreview.duration;
				this.mediaOriginalWidth = width;
				this.mediaOriginalHeight = height;
				this.mediaWidth = width;
				this.mediaHeight = height;
				this.duration = duration;
			}
		},
		checkDuplicateIndex() {
			// if(this.)
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.mediaLayerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = this.$t('Other item also using this layer, only one item at a time will be displayed');
			return text1;
		},
		resetSizePosition() {
			this.mediaX = 0;
			this.mediaY = 0;
			this.mediaPosition = 'default';
			if (this.data.content) {
				const content = JSON.parse(this.data.content);
				this.mediaWidth = content.original_width;
				this.mediaHeight = content.original_height;
			}
		},
		rescaleSize() {
			if (this.data.content && this.rundown) {
				const displayWidth = this.rundown.display && this.rundown.display.displaySize.width ? this.rundown.display.displaySize.width : 1920;
				const displayHeight = this.rundown.display && this.rundown.display.displaySize.height ? this.rundown.display.displaySize.height : 1080;
				const spaceCanvasWidth = displayWidth - this.mediaWidth;
				const spaceCanvasHeight = displayHeight - this.mediaHeight;
				const content = JSON.parse(this.data.content);
				this.mediaPosition = 'custom';
				// calculate width and height to keeping the aspect ratio based on the output size on rundown
				const ratioOriginal = Math.min(displayWidth / content.original_width, displayHeight / content.original_height);
				// check condition if image not fill canvas & not fit to canvas
				if (((spaceCanvasWidth === 0 && spaceCanvasHeight === 0) || (this.mediaX === 0 && this.mediaY === 0)) || ((this.mediaHeight !== content.original_width * ratioOriginal) && (this.mediaHeight !== content.original_height * ratioOriginal))) {
					this.mediaWidth = content.original_width * ratioOriginal;
					this.mediaHeight = content.original_height * ratioOriginal;
					// change position
					this.mediaX = (displayWidth - this.mediaWidth) / 2;
					this.mediaY = (displayHeight - this.mediaHeight) / 2;
				// scaling to fill no matter what the size of media
				} else {
					const ratioFill = Math.max(displayWidth / content.original_width, displayHeight / content.original_height);
					this.mediaWidth = content.original_width * ratioFill;
					this.mediaHeight = content.original_height * ratioFill;
					// change position
					this.mediaX = 0;
					this.mediaY = 0;
				}
			}
		},
		checkNameSpace(name) {
			return name.indexOf(' ') <= 0;
		},
		async checkMediaCached(key, path) {
			// cheking media cache
			this.isCaching = true;
			this.isCached = false;
			localforage.getItem(key).then(async (value) => {
				// console.log(value);
				if (!value) {
					const videoBlob = await getVideoBlob(path).catch(() => {
						this.isCaching = false;
						this.isCached = false;
					});
					localforage.setItem(key, videoBlob, (err) => {
						if (!err) {
							this.isCaching = false;
							this.isCached = true;
							this.$notify({
								group: 'app',
								type: 'success',
								title: 'Media Saved',
								text: 'Media is cached',
							});
						} else {
							this.isCaching = false;
							this.isCached = false;
						}
						// this.checkVideoSpec(value);
						this.getMediaDuration(videoBlob);
					});
				}
			});
			this.checkCached(key);
		},
		getMediaDuration(videoBlob) {
			const video = new Video(videoBlob);
			this.checkVideoSpec(videoBlob);
			const videoPreview = document.createElement('video');
			videoPreview.preload = 'metadata';
			// init size image to fit in canvas
			const outputSize = localStorage.getItem(`default_output_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_output_size_${this.user.id}`)) : null;
			const outputSizeWidth = outputSize && outputSize.width ? outputSize.width : 1920;
			const outputSizeHeight = outputSize && outputSize.height ? outputSize.height : 1080;
			// start set data
			videoPreview.onloadedmetadata = () => {
				window.URL.revokeObjectURL(video.src);
				const width = videoPreview.videoWidth;
				const height = videoPreview.videoHeight;
				const duration = videoPreview.duration;
				this.mediaOriginalWidth = width;
				this.mediaOriginalHeight = height;
				this.duration = duration;
				// change size based on ratio and canvas
				const ratioOriginal = Math.min(outputSizeWidth / width, outputSizeHeight / height);
				this.mediaWidth = width * ratioOriginal;
				this.mediaHeight = height * ratioOriginal;
				// change position
				this.mediaX = (outputSizeWidth - this.mediaWidth) / 2;
				this.mediaY = (outputSizeHeight - this.mediaHeight) / 2;
				// get range duration
				const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
				const minutes = parseInt(parseInt(duration % 3600) / 60);
				const seconds = parseInt(duration % 60);
				const hoursLabel = hours < 10 ? `0${hours}` : hours;
				const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
				const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
				const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
				this.mediaDuration = durationLabel;
				// reset value to default if user change the media
				this.outPoint = this.mediaDuration;
				this.inPoint = '00:00:00';
			};
			videoPreview.src = URL.createObjectURL(videoBlob);
		},
		selectParent(item) {
			this.selectedParent = item;
			this.keywordSearchParent = '';
		},
		removeParent() {
			this.selectedParent = null;
			this.keywordSearchParent = '';
		},
		selectOnComplete(item) {
			this.selectedOnComplete = item;
			this.keywordSearchOnComplete = '';
		},
		removeOnComplete() {
			this.selectedOnComplete = null;
			this.keywordSearchOnComplete = '';
		},
		convertDecimalToTime(duration) {
			const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
			const minutes = parseInt(parseInt(duration % 3600) / 60);
			const seconds = parseInt(duration % 60);
			const hoursLabel = hours < 10 ? `0${hours}` : hours;
			const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
			const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
			const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
			return durationLabel;
		},
		onInputEnter(props, value) {
			if (props === 'opacity') this.mediaOpacity = value;
			if (props === 'layer') this.mediaLayerIndex = value;
			if (props === 'borderThickness') this.borderThickness = value;
			if (props === 'top') this.cropTop = value;
			if (props === 'bottom') this.cropBottom = value;
			if (props === 'left') this.cropLeft = value;
			if (props === 'right') this.cropRight = value;
			if (props === 'delay') this.childOrder = value;
			if (props === 'inPoint') this.inPoint = value;
			if (props === 'outPoint') this.outPoint = value;
			if (props === 'imageDuration') this.imageDuration = value;

		},
		async getMediaByUrl(mediaUrl) {
			const mediaUrlResult = mediaUrl.split('.com/');
			const callback = (response) => {
				const data = response.data;
				this.mediaId = data.id;
				this.checkMediaCached(`media_${data.id}`, mediaUrl);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			mediasApi.getByUrl(mediaUrlResult[1], callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		content() {
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			return content;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
		mediaParams() {
			const mediaLabel = this.mediaLabel.trim();
			const parentItemId = this.selectedParent && this.selectedParent.id ? this.selectedParent.id : null;
			const onCompleteItemId = this.selectedOnComplete && this.selectedOnComplete.id ? this.selectedOnComplete.id : null;

			const content = {
				id: this.mediaId,
				type: this.mediaType,
				loop: this.mediaLoop,
				muted: this.mediaMute,
				thumbnail: this.mediaThumbnail,
				opacity: this.mediaOpacity / 100,
				url: this.mediaUrl,
				label: mediaLabel,
				position: this.mediaPosition,
				cropTop: this.cropTop,
				cropBottom: this.cropBottom,
				cropLeft: this.cropLeft,
				cropRight: this.cropRight,
				isEnableCrop: this.isEnableCrop,
				x: this.mediaX,
				y: this.mediaY,
				isRatio: this.isRatio,
				isPosition: this.isPosition,
				original_width: this.mediaOriginalWidth,
				original_height: this.mediaOriginalHeight,
				duration: this.duration,
				isEnableBorder: this.isEnableBorder,
				borderColor: this.borderColor,
				borderThickness: this.borderThickness,
				hasPlayed: this.hasPlayed,
				isParent: this.isParent,
				parentItem: parentItemId,
				onCompleteItem: onCompleteItemId,
				childOrder: this.childOrder,
				inPoint: this.inPoint || '00:00:00',
				outPoint: this.outPoint || this.mediaDuration || this.getExistingOldDuration,
				imageDuration: this.imageDuration,
				volumeVideo: this.volumeVideo,
				blendMode: this.blendMode,
			};
			if (this.mediaWidth < 75) {
				content.width = 75;
			} else {
				content.width = this.mediaWidth;
			}
			if (this.mediaHeight < 75 && !this.isRatio) {
				content.height = 75;
			} else if (this.mediaHeight <= 75 && this.isRatio && this.mediaWidth === 75) {
				content.height = 42;
			} else {
				content.height = this.mediaHeight;
			}
			const contentString = JSON.stringify(content);
			const params = {
				name: mediaLabel || 'Default Media',
				type: this.mediaType,
				content: contentString,
				layer_index: this.mediaLayerIndex,
				rundown_id: this.rundownId,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		showTitle() {
			return this.data && this.mediaLabel !== '';
		},
		propertyTitle() {
			const type = this.data ? toTitleCase(this.data.type) : '';
			const label = this.mediaLabel;
			const title = `${type} - ${label}`;
			return title;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.mediaLayerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		filteredData() {
			return this.data;
		},
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			let finalResult = filteredParent.filter(item => item.type !== 'separator');
			if (this.keywordSearchParent) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchParent.toUpperCase()));
				return finalResult;
			}
			if (this.keywordSearchOnComplete) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchOnComplete.toUpperCase()));
				return finalResult;
			}
			return finalResult;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		mediaMaxDuration() {
			let duration = 0;
			if (this.content && this.content.duration) {
				duration = Math.floor(this.content.duration);
				return duration;
			}
			return duration;
		},
		mediaInMaxDuration() {
			const hms = this.outPoint;// your input string
			const a = hms.split(':'); // split it at the colons
			// minutes are worth 60 seconds. Hours are worth 60 minutes.
			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			return JSON.stringify(seconds - 1);
		},
		getExistingOldDuration() {
			const duration = this.content && this.content.duration ? this.content.duration : '0';
			const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
			const minutes = parseInt(parseInt(duration % 3600) / 60);
			const seconds = parseInt(duration % 60);
			const hoursLabel = hours < 10 ? `0${hours}` : hours;
			const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
			const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
			const durationLabel = `${hoursLabel}:${minutesLabel}:${secondsLabel}`;
			return durationLabel;
		},
		isUserEditing() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index] ? this.items[index].active_edit : null;
		},
	},
	watch: {
		mediaFile() {
			let type = 'image';
			if (this.mediaFile && this.mediaFile.type.includes('video')) {
				type = 'video';
			}
			this.mediaType = type;
		},
		data() {
			this.mediaLayerIndex = this.data.layer_index;
			this.mediaLabel = this.data.name;
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			if (content) {
				const isSame = this.mediaUrl === content.url;
				this.mediaUrl = content.url;
				this.mediaId = content.id;
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
					const videoKey = `media_${content.id}`;
					if (!isSame) {
						this.checkMediaCached(videoKey, this.mediaUrl);
					}
				} else {
					this.isActiveEdit = false;
				}
				this.mediaType = content.type;
				this.mediaLoop = content.loop;
				this.mediaThumbnail = content.thumbnail;
				this.mediaOpacity = content.opacity * 100;
				this.mediaWidth = content.width;
				this.mediaHeight = content.height;
				this.mediaPosition = content.position;
				this.mediaOriginalWidth = content.original_width;
				this.mediaOriginalHeight = content.original_height;
				this.blendMode = content.blendMode;
				this.mediaX = content.x;
				this.mediaY = content.y;
				this.mediaMute = content.muted;
				this.isRatio = content.isRatio;
				this.isPosition = content.isPosition;
				this.cropTop = content.cropTop || 0;
				this.cropBottom = content.cropBottom || 0;
				this.cropLeft = content.cropLeft || 0;
				this.cropRight = content.cropRight || 0;
				this.isEnableCrop = content.isEnableCrop;
				if (content.duration) this.duration = content.duration;
				this.isEnableBorder = content.isEnableBorder;
				this.borderColor = content.borderColor || '#FFFFFF';
				this.borderThickness = content.borderThickness || 0;
				this.hasPlayed = content.hasPlayed;
				this.isParent = content.isParent;
				// this.parentItem = this.filteredItems.find(item => item.id === content.parentItem) || '';
				this.selectedParent = this.filteredItems.find(item => item.id === content.parentItem) || '';
				this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';

				this.childOrder = content.childOrder;
				this.inPoint = content.inPoint || '00:00:00';
				this.outPoint = content.outPoint || '00:00:01';
				this.volumeVideo = content.volumeVideo;
			}
		},
		async media() {
			if (this.media) {
				this.isNotOptimizedPlayback = false;
				const isSame = this.mediaId === this.media.id;
				this.mediaId = this.media.id;
				this.mediaUrl = this.media.path;
				this.mediaLabel = this.media.name;
				this.mediaType = this.media.type;
				this.mediaThumbnail = this.media.thumbnail;
				this.hasPlayed = false;
				this.duration = this.media.duration;
				// init size image to fit in canvas
				const outputSize = localStorage.getItem(`default_output_size_${this.user.id}`) ? JSON.parse(localStorage.getItem(`default_output_size_${this.user.id}`)) : null;
				const outputSizeWidth = outputSize && outputSize.width ? outputSize.width : 1920;
				const outputSizeHeight = outputSize && outputSize.height ? outputSize.height : 1080;
				// start set data
				if (this.mediaType === 'image') {
					const image = new Image();
					image.src = this.mediaUrl;
					image.onload = () => {
						const originalWidth = image.width;
						const originalHeight = image.height;
						this.mediaOriginalWidth = originalWidth;
						this.mediaOriginalHeight = originalHeight;
						// change size based on ratio and canvas
						const ratioOriginal = Math.min(outputSizeWidth / originalWidth, outputSizeHeight / originalHeight);
						this.mediaWidth = originalWidth * ratioOriginal;
						this.mediaHeight = originalHeight * ratioOriginal;
						// change position
						this.mediaX = (outputSizeWidth - this.mediaWidth) / 2;
						this.mediaY = (outputSizeHeight - this.mediaHeight) / 2;
					};
				} else {
					this.videoUrl = this.media.thumbnail;
					this.outPoint = this.convertDecimalToTime(this.duration);
				}
				const videoKey = `media_${this.mediaId}`;
				// if (!isSame) {
				localforage.getItem(videoKey).then((value) => {
					if (value) {
						this.checkVideoSpec(value);
						this.getMediaDuration(value);
						this.isCached = true;
					} else {
						this.checkMediaCached(videoKey, this.mediaUrl);
					}
				});
				// }
			}
		},
		mediaLoop() {
			if (this.mediaLoop) {
				this.selectedOnComplete = null;
			}
		},
		volumeVideo() {
			if (this.volumeVideo > 0) {
				this.mediaMute = false;
			} else {
				this.mediaMute = true;
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		if (!this.media) {
			this.isCaching = false;
			this.isCached = false;
		}
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
		this.$nextTick(() => {
			this.initData();
		});
		this.isLoading = true;
		this.isRequired = false;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 400);
	},
};
</script>
